<!-- Stupid hack to get around stacking context issues, I'd much rather have this wherever it's used -->

<template>
  <transition-group leave-active-class="duration-300 ease-in" leave-to-class="opacity-0">
    <div
      v-for="tooltip in tooltips"
      class="fixed z-[999] block p-[5px]"
      :style="{
        top: tooltip.y + 'px',
        left: tooltip.x + 'px',
      }"
      :key="tooltip.id || tooltip.text"
    >
      <div
        class="relative rounded bg-gp-charcoal-grey p-2.5 text-[13px] leading-[1.3] shadow-[0_3px_6px_0_rgba(0,0,0,0.35)]"
      >
        {{ tooltip.text }}
      </div>
    </div>
  </transition-group>
</template>

<script setup lang="ts">
import { useTooltips } from "./tooltips";
const { tooltips } = useTooltips();
</script>
